module.exports = __webpack_public_path__ + "img/standard-car.0af62b50.svg";